import { createLookupTable } from '../utils';

const statuses = {
  paid: 'success',
  unpaid: 'warning',
  expired: 'error',
} as const;

export type PaymentLabel = keyof typeof paymentTable;
export const paymentTable = createLookupTable(statuses, 'payment');
